import React, { useState } from "react";
import HomeHeroSection from "../sections/HomeHeroSection.jsx";
import HomeFourthSection from "../sections/HomeFourthSection.jsx";
import HomeSeventhSection from "../sections/HomeSeventhSection.jsx";
import HomeNinthSection from "../sections/HomeNinthSection.jsx";
import AboutStatSection from "../sections/AboutStatSection.jsx";
import HomeServicesVerticalSection from "../sections/HomeServicesVerticalSection.jsx";
import HomeContactSection from "../sections/HomeContactSection.jsx";
import HomeApproachSection from "../sections/HomeApproachSection.jsx";

import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { useLocation } from "react-router-dom";
import PartnersSection from "../sections/PartnersSection.jsx";
import ScrollSnake from "../components/ScrollSnake.jsx";


export const AwardsComponent = ({ videoMuted, isPlaying, videoReady, playerRef, setVideoMuted, setIsPlaying, setVideoReady, isHome = false }) => {
  const awardRefs = useRef([]);

  const awards = [
    "/new-final-data/awards/1.png",
    "/new-final-data/awards/2.png",
    "/new-final-data/awards/3.png",
    "/new-final-data/awards/4.png",
  ]

  useEffect(() => {
    // Create rotation animation for each award
    awardRefs.current.forEach((awardRef) => {
      if (awardRef) {
        gsap.to(awardRef, {
          rotation: "+=360deg",
          duration: 3,
          ease: "none", // Linear easing
          repeat: -1    // Infinite repeat
        });
      }
    });

    // Cleanup function to kill all animations when component unmounts
    return () => {
      awardRefs.current.forEach((awardRef) => {
        if (awardRef) {
          gsap.killTweensOf(awardRef);
        }
      });
    };
  }, [awards]);



  const toggleVideoMute = useLocation().pathname != "/" ? () => { } : () => {
    const newMutedState = !videoMuted;

    // Use requestAnimationFrame for smooth state updates
    requestAnimationFrame(() => {
      setVideoMuted(newMutedState);

      // Ensure video continues playing smoothly and apply mute state
      if (playerRef.current && videoReady) {
        const player = playerRef.current;
        
        // For ReactPlayer, we need to get the internal player
        if (typeof player.getInternalPlayer === 'function') {
          try {
            const internalPlayer = player.getInternalPlayer();
            if (internalPlayer) {
              internalPlayer.muted = newMutedState;
              
              // Ensure video is playing
              if (!isPlaying) {
                setIsPlaying(true);
                internalPlayer.play().catch(console.error);
              }
            }
          } catch (error) {
            console.log('Error controlling video mute:', error);
          }
        }
      }
    });
  };

  return (
    <div className="fixed bg-transparent hidden xl:block w-fit z-[1000] bottom-5 left-5 ">

      <div className="space-y-5 w-fit absolute top-1/2 -translate-y-1/2 hidden ">

        {awards.map((award, index) => {
          return (
            <div
              key={index}
              ref={(el) => (awardRefs.current[index] = el)}
              className="w-19 h-19 bg-white rounded-full overflow-hidden"
            >
              <img
                className="h-full w-full object-contain"
                src={award}
                alt={`Award ${index + 1}`}
              />
            </div>
          );
        })}
      </div>
      {/* Mute Toggle Button */}
      {useLocation().pathname === "/" && <button
        onClick={toggleVideoMute}
        className="pointer-events-auto  h-[70px] w-[70px] scale-[.65]  flex items-center justify-center z-[100000] dark:bg-white/20 bg-white/80 backdrop-blur-sm border border-black/20 rounded-full p-3 hover:bg-white/90 transition-all duration-300 group"
        aria-label={videoMuted ? "Unmute video" : "Mute video"}
      >
        {videoMuted ? (
          // Muted icon
          <svg
            className="w-10 h-10 text-black/50 group-hover:scale-110 transition-transform"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 0 0 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z" />
          </svg>
        ) : (
          // Unmuted icon
          <svg
            className="w-10 h-10 text-black/50 group-hover:scale-110 transition-transform"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
          </svg>
        )}
      </button>}
    </div>
  );
};


const Home = () => {
  const [videoMuted, setVideoMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const [videoReady, setVideoReady] = useState(false);
  const playerRef = useRef();

  return (
    <>
      <AwardsComponent videoMuted={videoMuted} isPlaying={isPlaying} videoReady={videoReady} playerRef={playerRef} setVideoMuted={setVideoMuted} setIsPlaying={setIsPlaying}
        setVideoReady={setVideoReady} />
      <div className="h-full w-full bg-transparent relative">
        <div className="h-full w-full relative z-40 pointer-events-auto dark:bg-black bg-white">
          <HomeHeroSection videoMuted={videoMuted} videoReady={videoReady} isPlaying={isPlaying} playerRef={playerRef}
            setVideoMuted={setVideoMuted}
            setIsPlaying={setIsPlaying}
            setVideoReady={setVideoReady}
          />
          <HomeFourthSection />
          <HomeServicesVerticalSection />
          <AboutStatSection />
          <HomeApproachSection />
          <HomeContactSection />
          <HomeNinthSection />
          <PartnersSection />
        </div>

        {/* <ScrollSnake /> */}

      </div>
    </>
  );
};

export default Home;
